import { createSelector } from 'reselect';
import { IState } from '../createStore';

const selectPlaylistState = (state: IState) => state.app.persistedState.playlist;

export const selectPlaylist = createSelector(
  [selectPlaylistState],
  (playlistState) => playlistState?.playlist ?? []
);
